import En from "../../data/English";
import Kr from "../../data/Korean";
import Cn from "../../data/Chinese";

const languages = {
  kr: Kr,
  en: En,
  cn: Cn,
};

export const Language = {
  KOREAN: "kr",
  ENGLISH: "en",
  CHINESE: "cn",
  LANG: "lang",
};

export { languages };
